import client from './client';

export async function getLoginHistoryList(params) {
  const res = await client.get('/admin/history/login', { params });
  return res.data;
}

export async function getUseHistoryList(params) {
  const res = await client.get('/admin/history/use', { params });
  return res.data;
}
